import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { clearAllFilter } from "../../features/filter/filterSlice";
import { fetchTransactions } from "../../features/transaction/transactionSlice";
import Transaction from "./Transaction";
import TransactionSkeleton from "./TransactionSkeleton";

export default function Transactions() {
  const dispatch = useDispatch();

  const { transactions, isLoading, isError } = useSelector(
    (state) => state.transaction
  );
  const { page, search, type } = useSelector((state) => state.filter || {});
  // Current page tracking
  const currUrl = useLocation();
  const currentPage = (path) => {
    if (path === "/") return "home";
    else if (path === "/transactions") return "transactions";
    else return null;
  };

  useEffect(() => {
    dispatch(
      fetchTransactions({
        page: currentPage(currUrl.pathname),
        pageNum: page,
        search,
        type,
      })
    );
  }, [dispatch, currUrl.pathname, page, search, type]);

  // decide what to render
  let content = null;
  if (isLoading)
    content = TransactionSkeleton(
      currentPage(currUrl.pathname) === "home" ? 5 : 10
    );

  if (!isLoading && isError)
    content = <p className="error">There was an error occured</p>;

  if (!isLoading && !isError && transactions?.length > 0) {
    content = transactions.map((transaction) => (
      <Transaction key={transaction.id} transaction={transaction} />
    ));
  }

  if (!isLoading && !isError && transactions?.length === 0) {
    content = <p>No transactions found!</p>;
  }

  return (
    <>
      <p className="second_heading">Your Transactions:</p>
      <div className="conatiner_of_list_of_transactions">
        <ul>{content}</ul>
        {currUrl.pathname === "/" && (
          <Link to="/transactions" onClick={() => dispatch(clearAllFilter())}>
            <button className="gotoBtn">View all</button>
          </Link>
        )}
      </div>
    </>
  );
}
